'use client'

import Box from '@mui/material/Box'

import Money2020Form from '@/components/Money2020Form'
import { HUBSPOT_FORM_IDS } from '@/utills/constants'

export default function Page() {
    return (
        <Box
            pt={{
                xs: 0,
                sm: 0,
                md: 9,
                lg: 9,
                xl: 9,
            }}
        >
            <Money2020Form hubspotFormId={HUBSPOT_FORM_IDS.money2020} />
        </Box>
    )
}
